import { GetStaticProps } from 'next';
import { serialize } from 'next-mdx-remote/serialize';
import fs from 'fs';
import path from 'path';
import listings from '../jobs.json';

export const getStaticPaths = () => {
    return {
        paths: [{ params: { jobId: 'eng-rtc1' } }],
        fallback: 'blocking',
    };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
    const jobId = params.jobId as string;
    const fullPath = path.join(process.cwd(), 'pages', 'jobs', `${jobId}.md`);
    const fileContents = fs.readFileSync(fullPath, 'utf8');
    const mdxSource = await serialize(fileContents);
    return {
        props: {
            source: mdxSource,
            listing: listings.find((listing) => listing.playbackId === jobId),
        },
    };
};

export { default } from './JobListing';
